import React from 'react'
import GoogleMap from 'google-maps-react-markers'
import { translation } from 'assets/translations/translations'
import './Footer.css'

type Props = {
  language: string
}

const Footer = ({ language }: Props) => {
  return (
    <footer className='footer-main'>
      <div className='footer-grid'>
        <div className='map-card'>
          <div style={{ height: '320px', width: '100%' }} id='inner-map'>
            <GoogleMap
              apiKey='AIzaSyDUXU7k_li8p4vWnNtKo_S2hVz7ss62IlQ'
              defaultCenter={{ lat: 41.995505, lng: 21.404493 }}
              defaultZoom={18}
              mapMinHeight='320px'
            >
              <Marker lat={41.995505} lng={21.404493} />
            </GoogleMap>
          </div>
        </div>

        <div className='contact-us'>
          <span className='footer-kicker'>Contact</span>
          <h2 className='footer-title'>{translation(language, 'contactUs')}</h2>

          <form
            action='mailto:ile@ile-soft.com'
            method='post'
            className='footer-mail-form'
          >
            <button type='submit' className='email-btn'>
              {translation(language, 'emailBtn')}
            </button>
          </form>

          <div className='working-hours'>
            <span>{translation(language, 'open')}</span>
            <span>{translation(language, 'openOn')}</span>
            <span className='phone-line'>
              {translation(language, 'phone')}
              {translation(language, 'phoneNr')}
            </span>
          </div>
        </div>
      </div>
    </footer>
  )
}

// eslint-disable-next-line
const Marker = (_props: any) => {
  return (
    <div>
      <div className='marker'></div>
      <span className='beacon'></span>
    </div>
  )
}

export default Footer